// MIT License - Copyright (c) 2026 Doug McNall - See .kiro/steering/general/development-standards.md for full license

/**
 * Ship Health Configuration
 * 
 * Contains all ship health system settings, damage thresholds, and repair costs.
 */

export const shipHealthConfig = {
  // Starting health for each system
  startingHealth: {
    hull: 100,
    shields: 100,
    engines: 100,
    weapons: 100,
    lifeSupport: 100,
    sensors: 100,
    power: 100
  },
  
  // Critical thresholds (when system becomes critical)
  criticalThresholds: {
    hull: 30,
    shields: 20,
    engines: 25,
    weapons: 30,
    lifeSupport: 15,
    sensors: 20,
    power: 10
  },
  
  // Status thresholds (for display)
  statusThresholds: {
    damaged: 50,      // Below 50% = DAMAGED
    caution: 80,      // Below 80% = CAUTION
    optimal: 80       // Above 80% = OPTIMAL
  },
  
  // Default fallback values
  defaults: {
    maxHealth: 100,
    criticalThreshold: 20
  },
  
  // Hull damage cascade
  hullDamageCascade: {
    chance: 0.3,              // 30% chance to damage other systems when hull is hit
    damageMultiplier: 0.5     // 50% of hull damage applied to random system
  },
  
  // System damage penalties
  penalties: {
    // Hull damage thresholds
    hull: {
      minorThreshold: 50,     // Below 50% = minor penalty
      criticalThreshold: 25,  // Below 25% = critical penalty
      minorPenalty: 0.9,      // 10% reduction
      criticalPenalty: 0.7    // 30% reduction
    },
    
    // Engine damage affects warp speed
    engines: {
      minorThreshold: 50,
      criticalThreshold: 25,
      minorPenalty: 0.85,     // 15% slower
      criticalPenalty: 0.6    // 40% slower
    },
    
    // Weapon damage affects fire rate
    weapons: {
      minorThreshold: 50,
      criticalThreshold: 25,
      minorPenalty: 0.8,      // 20% slower
      criticalPenalty: 0.5    // 50% slower
    },
    
    // Shield damage affects protection
    shields: {
      minorThreshold: 50,
      criticalThreshold: 25,
      minorPenalty: 0.85,     // 15% less protection
      criticalPenalty: 0.6    // 40% less protection
    },
    
    // Sensor damage affects scan quality
    sensors: {
      minorThreshold: 50,
      criticalThreshold: 25,
      minorPenalty: 0.9,      // 10% reduced
      criticalPenalty: 0.7    // 30% reduced
    },
    
    // Power damage affects all systems
    power: {
      minorThreshold: 50,
      criticalThreshold: 25,
      minorPenalty: 0.95,     // 5% reduced
      criticalPenalty: 0.8    // 20% reduced
    }
  },
  
  // Repair costs (fuel percentage per HP)
  repairCostPerHP: 0.5
};
